import { z } from "zod";

import { TEXT_NOTE_LENGTH } from "~/common/constants";

export const addActivityFeedNoteSchema = z.object({
  note: z
    .string()
    .min(1, "Note is a mandatory field.")
    .max(TEXT_NOTE_LENGTH, `Maximum ${TEXT_NOTE_LENGTH} characters allowed`),
});
